import React, { PureComponent } from 'react';
import onClickOutside from 'react-onclickoutside';
import { InjectedIntl } from 'react-intl';
import { writeText } from 'clipboard-polyfill';
import { Button } from '@nbc-design/button';
import { Copy as CopyIcon } from '@nbc-design/icons/lib/web/Copy';
import { SuccessReversedColor } from '@nbc-design/icons/lib/web/SuccessReversedColor';

type CopyProps = { value: string; intl: InjectedIntl };

export class Copy extends PureComponent<CopyProps, { isCopied: boolean }> {
  constructor(props) {
    super(props);
    this.state = { isCopied: false };
  }

  componentDidUpdate() {
    if (this.state.isCopied) {
      writeText(this.props.value);
    }
  }

  handleClickOutside() {
    this.setState({ isCopied: false });
  }

  render() {
    const { intl } = this.props;
    const { isCopied } = this.state;
    return (
      <Button
        type="button"
        appearance="link"
        className="relative"
        data-test="button_copy"
        onClick={() => this.setState({ isCopied: true })}
      >
        {isCopied && (
          <div
            data-test="copy_message"
            className="absolute h-[39px] leading-[39px] rounded-[8px] shadow-[0_4px_8px_0_rgba(39,49,57,0.15)] bg-[#273139] p-0 text-sm text-white w-[250px] -top-[45px] -ml-[125px] left-1/2 flex justify-center items-center"
          >
            <SuccessReversedColor title="success-reversed-color" className="mr-2" size="xsmall" />
            {intl.formatMessage({ id: 'copy.message' })}
          </div>
        )}
        <CopyIcon title={intl.formatMessage({ id: 'copy.button' })} className="fill-electric-blue" size="small" />{' '}
        {intl.formatMessage({ id: 'copy.button' })}
      </Button>
    );
  }
}

const EnhancedCopy = onClickOutside(Copy);
export default ({ value, intl }: CopyProps) => <EnhancedCopy value={value} intl={intl} />;
